import ThemedComponent from '../../hoc/ThemedComponent';

import { default as NewsPageViewDefault } from './NewsPage/View';
import { default as NewsPageView3 } from '../../themes/3/pages/news/NewsPage';
import { default as NewsPageView4 } from '../../themes/4/pages/news/NewsPage';

const ThemedNewsPage = {
  default: NewsPageViewDefault,
  // 3: NewsPageView3,
  // 4: NewsPageView4,
};

export const NewsPageView = ThemedComponent(ThemedNewsPage);